/**
 * Links to advanced product areas — hidden from primary nav in core journey mode.
 * Routes and backend remain fully available.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Bell, Dna, Flame, Headphones, Lock, MapPin, Sparkles, Users } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { DNA_UPLOAD_VISIBLE } from '../../config/testerRelease';

const LINKS = [
  { to: '/story-studio', label: 'AI Story Studio', icon: Sparkles },
  { to: '/storybook', label: 'Storybook Mode', icon: Sparkles },
  { to: '/vault', label: 'Family Handover Vault', icon: Lock },
  { to: '/memorials', label: 'Memorial Bridge', icon: Flame },
  { to: '/reminders', label: 'Reminders', icon: Bell },
  { to: '/family-spaces', label: 'Family Spaces', icon: Users },
  { to: '/gene-engine', label: 'Gene Engine', icon: Dna, hidden: true },
];

export function SettingsAdvancedFeatures() {
  const visible = LINKS.filter((l) => !l.hidden && (l.to !== '/dna' || DNA_UPLOAD_VISIBLE));
  if (DNA_UPLOAD_VISIBLE) {
    visible.splice(4, 0, { to: '/dna', label: 'DNA profiles', icon: Dna });
  }
  visible.push({ to: '/help', label: 'Places & things, audiobook, timeline', icon: MapPin, subtitle: 'Open an archive → Menu for tree tools' });
  visible.push({ to: '/help', label: 'Audiobook & advanced exports', icon: Headphones, subtitle: 'Available inside each archive' });

  return (
    <Card className="rounded-2xl border border-[#e8e2d8] bg-[#fffcf7]/90 shadow-sm" data-testid="settings-advanced-features">
      <CardHeader className="pb-4">
        <CardTitle className="font-serif text-lg font-light text-[#1c1917]">More features</CardTitle>
        <CardDescription className="text-[#5c534a]">
          These tools are still here when you need them. We are focusing the main experience on people, memories and your Legacy Book.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {visible.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className="flex items-center gap-3 rounded-xl border border-[#e8e2d8]/80 bg-white/60 px-4 py-3 text-sm text-[#5c534a] transition hover:border-[#c9a961]/35 hover:bg-[#faf8f5] hover:text-[#1c1917]"
                >
                  <Icon className="h-4 w-4 shrink-0 text-[#8b7355]" aria-hidden />
                  <span className="min-w-0 flex-1">
                    <span className="block font-medium">{item.label}</span>
                    {item.subtitle ? (
                      <span className="mt-0.5 block text-xs text-muted-foreground">{item.subtitle}</span>
                    ) : null}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}

export default SettingsAdvancedFeatures;
